"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

const defaultVideoComponent = {
  "@type": "@builder.io/sdk:Element",
  component: {
    name: "VideoPlayer",
    options: {
      videoType: "hosted internally",
      hostedVideoConfiguration: {
        desktopSrc:
          "https://cdn.builder.io/o/assets%2F90293f7dc9704cb5935f357315020051%2Fdb83e0ca80d24c6da4c2fb863cd65ebb%2Fcompressed?apiKey=90293f7dc9704cb5935f357315020051&token=db83e0ca80d24c6da4c2fb863cd65ebb&alt=media&optimized=true",
      },
    },
  },
};

export const videoContainerInputs = [
  {
    name: "title",
    type: "string",
    defaultValue: "Title",
  },
  {
    name: "childBlocks",
    type: "uiBlocks",
    onChange: (options: Map<string, unknown>) => {
      const MAX_VIDEO_COMPONENTS = 3;
      const childBlocks = options.get("childBlocks");

      if (!Array.isArray(childBlocks)) return;

      const videoComponents = childBlocks.filter(
        (block) => block.component?.name === "VideoPlayer"
      );

      if (videoComponents.length !== childBlocks.length) {
        alert("Only Video Container related components are allowed");
      }

      if (videoComponents.length > MAX_VIDEO_COMPONENTS) {
        alert("Only 3 Video components are allowed");
      }

      options.set(
        "childBlocks",
        videoComponents.slice(0, MAX_VIDEO_COMPONENTS)
      );
    },

    defaultValue: Array(3).fill(defaultVideoComponent),
  },
] as const satisfies Inputs;

export const VideoContainerComponent: RegisteredComponent = {
  name: "VideoContainerComponent",
  friendlyName: "VideoContainerComponent",
  component: dynamic(async () =>
    withValidation(
      videoContainerInputs,
      (await import("./VideoContainer")).VideoContainer,
      "VideoContainer"
    )
  ),
  shouldReceiveBuilderProps: {
    builderBlock: true,
  },
  canHaveChildren: true,
  childRequirements: {
    message: "Only Video Container related components are allowed",
    query: {
      "component.name": {
        $in: ["VideoPlayer"],
      },
    },
  },
  inputs: videoContainerInputs,
};
